<template>
	<basic-container :block="isContentLoading" v-loading="isContentLoading">
		<el-tabs v-model="activeTab" v-if="policyDetails.holder">
			<el-tab-pane label="基本信息" name="information">
				<el-alert
					v-if="getShowRenewTips"
					:title="getShowRenewTips.renewTips"
					:type="getShowRenewTips.renewTipsType"></el-alert>
				<el-card header="保单信息">
					<div slot="header">
						<span>保单信息</span>
						<div style="float: right">
							<el-button
								v-if="isShowPdfPolicy"
								style="font-size: 1em; color: red; margin-right: 10px"
								type="text"
								@click="onShowPdfDialog(1)">
								查看电子保单
							</el-button>
							<el-button icon="el-icon-refresh" style="font-size: 14px" type="text" @click="onRefresh">刷新</el-button>
						</div>
					</div>
					<el-row>
						<el-col :span="3">险种名称：</el-col>
						<el-col :span="9">{{ policyDetails.productTitle }}</el-col>
						<el-col :span="3">保险公司：</el-col>
						<el-col :span="9">{{ policyDetails.insuranceCompany }}</el-col>
					</el-row>
					<el-row>
						<el-col :span="3">保单号：</el-col>
						<el-col :span="9" class="red-bold u-font-16">
							{{ policyDetails.policyNo || '----' }}
							<el-button
								v-if="policyDetails.policyNo"
								class="u-m-l-10"
								plain
								type="text"
								@click="onCopy(policyDetails.policyNo)">
								复制
							</el-button>
						</el-col>
						<el-col :span="3">保单状态：</el-col>
						<el-col v-if="!renewFlag && !payFlag" :span="9">
							<el-tag :type="getPolicyStatus.type">{{ getPolicyStatus.label }}</el-tag>
						</el-col>
						<el-col v-if="renewFlag" :span="9">
							<div style="display: flex; align-items: center">
								<el-tag :type="getPolicyStatus.type">{{ getPolicyStatus.label }}</el-tag>
								<el-button
									v-if="!viewOnly"
									:loading="isShowLoading"
									style="margin-left: 40px"
									type="warning"
									@click="handleRenew">
									去续保
								</el-button>
							</div>
						</el-col>
						<el-col v-if="payFlag" :span="9">
							<div style="display: flex; align-items: center">
								<el-tag :type="getPolicyStatus.type">{{ getPolicyStatus.label }}</el-tag>
								<pay-btn
									v-if="!viewOnly"
									:pay-btn-data-temp="getOrderData"
									style="margin-left: 40px"
									@onPayOffLineSuccess="onPayOffLineSuccess"
									@onToOfflinePay="onToOfflinePay"></pay-btn>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="3">保单期限：</el-col>
						<el-col :span="9">{{ policyDetails.effectiveDate }} 至 {{ policyDetails.expiryDate }}</el-col>
						<el-col :span="3">总保费：</el-col>
						<el-col :span="9">
							{{ policyDetails.totalMoney }}元
							<el-button
								v-if="isShowPdfInvoice"
								style="padding: 4px 0; font-size: 1em; color: red"
								type="text"
								@click="onShowPdfDialog(3)">
								查看电子发票
							</el-button>
						</el-col>
					</el-row>

					<el-row v-if="policyDetails.invoice">
						<el-col :span="3">开票类型：</el-col>
						<el-col :span="9">{{ policyDetails.invoice.type === 1 ? '增值税专票' : '增值税普票' }}</el-col>
					</el-row>

					<div v-if="envConfig.isBxXsm()">
						<el-row v-if="policyDetails.payNo">
							<el-col :span="3">通知单号：</el-col>
							<el-col :span="9" style="font-weight: bold; color: red; font-size: 16px">
								{{ policyDetails.payNo }}
							</el-col>
						</el-row>
						<el-row v-if="policyDetails.applyNo">
							<el-col :span="3">投保单号：</el-col>
							<el-col :span="9" style="font-weight: bold; color: red; font-size: 16px">
								{{ policyDetails.applyNo }}
							</el-col>
						</el-row>
					</div>
				</el-card>
				<el-card v-if="policyDetails && policyDetails.holder" v-loading="isContentLoading" :header="onGetDes[0]">
					<el-row>
						<el-col :span="3">{{ onGetDes[1] }}</el-col>
						<el-col :span="9">
							{{ policyDetails.holder.unitName }}
							<el-button class="u-m-l-10" plain type="text" @click="onCopy(policyDetails.holder.unitName)">
								复制
							</el-button>
						</el-col>
						<el-col v-if="policyDetails.holder.legalPerson" :span="3">联系人：</el-col>
						<el-col v-if="policyDetails.holder.legalPerson" :span="9">{{ policyDetails.holder.legalPerson }}</el-col>
					</el-row>
					<el-row>
						<el-col :span="3">{{ onGetDes[4] }}</el-col>
						<el-col :span="9">
							{{ policyDetails.holder.unitCode }}
							<el-button class="u-m-l-10" plain type="text" @click="onCopy(policyDetails.holder.unitCode)">
								复制
							</el-button>
						</el-col>
						<el-col :span="3">手机号码：</el-col>
						<el-col :span="9">{{ policyDetails.holder.legalPersonMobile }}</el-col>
					</el-row>
					<el-row>
						<el-col :span="3">经营地址：</el-col>
						<el-col :span="9">
							{{ policyDetails.holder.areaInfo.province }}{{ policyDetails.holder.areaInfo.city
							}}{{ policyDetails.holder.areaInfo.district }}{{ policyDetails.holder.unitAddress }}
						</el-col>
					</el-row>
				</el-card>
				<el-card v-for="(insured, index) in insuredList" :key="insured.unitId" :offset="1">
					<div slot="header">
						<span v-if="insuredList.length > 1">{{ onGetDes[2] }}{{ index + 1 }}</span>
						<span v-else>{{ onGetDes[2] }}</span>
					</div>
					<el-row>
						<el-col :span="3">{{ onGetDes[3] }}</el-col>
						<el-col :span="9">
							{{ insured.unitName }}
							<el-button class="u-m-l-10" plain type="text" @click="onCopy(insured.unitName)">复制</el-button>
						</el-col>
						<el-col v-if="insured.legalPerson" :span="3">联系人：</el-col>
						<el-col v-if="insured.legalPerson" :span="9">{{ insured.legalPerson }}</el-col>
					</el-row>
					<el-row>
						<el-col :span="3">{{ onGetDes[4] }}</el-col>
						<el-col :span="9">
							{{ insured.unitCode }}
							<el-button class="u-m-l-10" plain type="text" @click="onCopy(insured.unitCode)">复制</el-button>
						</el-col>
						<el-col :span="3">手机号码：</el-col>
						<el-col :span="9">{{ insured.legalPersonMobile }}</el-col>
					</el-row>
					<el-row>
						<el-col :span="3">经营地址：</el-col>
						<el-col :span="10">
							{{ insured.areaInfo.province }}{{ insured.areaInfo.city }}{{ insured.areaInfo.district
							}}{{ insured.unitAddress }}
						</el-col>
					</el-row>
				</el-card>

				<el-card v-if="attachmentList.length > 0" :offset="1">
					<div slot="header">
						<span>附件</span>
					</div>
					<el-table :data="attachmentList" border style="width: 100%">
						<!-- 附件名称列 -->
						<el-table-column prop="name" label="附件名称" align="center">
							<template #default="{row}">
								<span class="file-name">{{ row }}</span>
							</template>
						</el-table-column>
						<!-- 下载操作列 -->
						<el-table-column label="操作" width="120" align="center">
							<template #default="{row}">
								<el-button type="text" size="small" @click="onDownloadAttach(row)">下载</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="保障人员" name="employee">
				<el-row :span="24">
					<el-col :md="24" :sm="24" :xs="24">
						<!--车意险-->
						<div v-if="this.insureType === 14" style="margin-top: 20px">
							<avue-crud :data="employeeList" :option="employeeOption" :page.sync="employeePage"></avue-crud>
						</div>
						<div v-else>
							<avue-crud
								ref="crud_emp"
								:data="employeeList"
								:option="employeeOption"
								:page.sync="employeePage"
								:table-loading="employeeLoading"
								@search-change="employeeSearchChange"
								@refresh-change="employeeRefreshChange"
								@size-change="employeeSizeChange"
								@current-change="employeeCurrentChange">
								<template v-if="!viewOnly" slot="menuLeft" slot-scope="{size}">
									<el-button
										v-if="isShowAddButton"
										:loading="isShowLoading"
										:size="size"
										icon="el-icon-plus"
										type="primary"
										@click="handleReplaceAdd()">
										增加保障人员
									</el-button>

									<el-button
										v-if="isShowReplaceMoreButton"
										:loading="isShowLoading"
										:size="size"
										icon="el-icon-sort"
										type="primary"
										@click="handleReplaceMore(0)">
										批量替换人员
									</el-button>

									<el-button
										v-if="isShowRenameMoreButton"
										:loading="isShowLoading"
										:size="size"
										icon="el-icon-sort"
										type="primary"
										@click="handleReplaceMore(1)">
										批量修改人员姓名
									</el-button>
								</template>
								<template v-slot:menuRight>
									<el-button
										:loading="isShowLoading"
										class="el-icon-download-emp"
										icon="el-icon-download"
										@click="onDownloadEmp"></el-button>
								</template>
								<template v-if="!viewOnly" slot="menu" slot-scope="scope">
									<el-button
										v-if="isShowReplaceButton"
										:loading="isShowLoading"
										icon="el-icon-sort"
										type="text"
										@click.native="handleReplaceSingle(scope.row, 0)">
										替换
									</el-button>

									<el-button
										v-if="isShowRenameButton"
										:loading="isShowLoading"
										icon="el-icon-sort"
										type="text"
										@click.native="handleReplaceSingle(scope.row, 1)">
										改名
									</el-button>
								</template>
								<template slot="empName" slot-scope="scope">
									<span v-if="scope.row.claimStatus == 1">
										{{ scope.row.empName }}
										<el-tag v-if="scope.row.claimStatus == 1" type="danger">存在出险</el-tag>
									</span>
									<span v-else>{{ scope.row.empName }}</span>
								</template>
								<template slot="insureMoney" slot-scope="scope">{{ scope.row.insureMoney }}万</template>
							</avue-crud>
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane v-if="this.insureType != 14" label="批改记录" name="endorsement">
				<el-row :span="24">
					<el-col :md="24" :sm="24" :xs="24">
						<avue-crud
							v-if="policyDetails && policyDetails.newProductid"
							ref="crud_change"
							:cell-style="endorsementCellStyle"
							:data="tableData"
							:option="endorsementOption"
							:page.sync="endorsementPage"
							:row-style="endorsementRowStyle"
							:table-loading="endorsementLoading"
							@search-change="endorsementSearchChange"
							@refresh-change="endorsementRefreshChange"
							@size-change="endorsementSizeChange"
							@current-change="endorsementCurrentChange">
							<template slot="menuLeft" slot-scope="{size}">
								<el-radio-group v-model="endorsementSearchForm.changeCode" @change="endorsementTypeChange">
									<el-radio-button :size="size" label="101">新增人员</el-radio-button>
									<el-radio-button :size="size" label="102">替换人员</el-radio-button>
									<el-radio-button :size="size" label="999">其他批改</el-radio-button>
								</el-radio-group>
							</template>
							<template slot="menu" slot-scope="{row}">
								<div
									v-if="endorsementSearchForm.changeCode == 101"
									class="u-flex-col u-col-center u-row-center"
									style="width: 100%">
									<div class="u-flex u-row-center">
										<el-button
											icon="el-icon-view"
											style="margin: 0 10px"
											type="text"
											@click="handleViewEndorsement(row)">
											查看
										</el-button>
										<el-button
											v-if="!viewOnly && row.status && row.status == 1"
											:icon="cancelStatusIcon"
											style="margin: 0 10px"
											type="text"
											@click="handleCancelEndorsement(row)">
											取消
										</el-button>
									</div>
									<div v-if="!viewOnly && row.status">
										<pay-btn
											v-if="row.status == 1"
											:pay-btn-data-temp="getItemOrderData(row)"
											@onPayOffLineSuccess="onPayOffLineSuccess"
											@onToOfflinePay="onToOfflinePay"></pay-btn>
										<el-button
											v-if="isShowAddButton && (row.status === 8 || row.status === 4)"
											:loading="isShowLoading"
											icon="el-icon-edit"
											type="text"
											@click="isJudgeCenter(EnumInsureType.add, row.recordId)">
											重新提交
										</el-button>
										<el-button
											v-if="row.status == 3 && isShowPdfPolicy"
											icon="el-icon-view"
											type="text"
											@click="onShowPdfDialog(2, row)">
											电子批单
										</el-button>
									</div>
									<el-button
										v-if="row.status == 1 && isDownloadPayFile(row.insureType)"
										:loading="isShowLoading"
										icon="el-icon-download"
										type="text"
										@click="onDownloadPayFile(row)">
										下载缴费通知书
									</el-button>
								</div>
								<template v-else-if="endorsementSearchForm.changeCode == 102">
									<el-button
										v-if="row.status && row.status == 3 && isShowPdfPolicy"
										icon="el-icon-view"
										type="text"
										@click="onShowPdfDialog(2, row)">
										电子批单
									</el-button>
								</template>
								<template v-else>
									<el-button icon="el-icon-view" type="text" @click="handleViewSurrender(row)">查看</el-button>
									<template v-if="!viewOnly">
										<el-button
											v-if="row.btn && row.btn.submitMaterial"
											icon="el-icon-upload"
											type="text"
											@click="handleSubmitMaterials(row)">
											提交材料
										</el-button>
										<el-button
											v-if="row.btn && row.btn.addMaterial"
											icon="el-icon-upload"
											type="text"
											@click="handleSupplementMaterials(row)">
											补传材料
										</el-button>
										<el-button
											v-if="row.btn && row.btn.addExpressNo"
											icon="el-icon-upload"
											type="text"
											@click="handleSubmitExpressNo(row)">
											上传快递单号
										</el-button>
									</template>
									<el-button
										v-if="row.btn && row.btn.showEndorse"
										icon="el-icon-view"
										type="text"
										@click="onShowPdfDialog(2, row)">
										电子批单
									</el-button>
								</template>
							</template>
						</avue-crud>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
		<el-dialog :visible.sync="endorsementDetailsDialogVisible" title="新增人员明细" top="25vh" width="60%">
			<avue-crud
				v-if="endorsementDetails.length > 0"
				ref="crud"
				:data="endorsementDetails"
				:option="endorsementDetailsOption"
				:table-loading="tableLoading"></avue-crud>
		</el-dialog>

		<product-choice
			:isShowProductChoiceTemp="isShowProductChoice"
			:product-list="productList"
			@onClickClose="onClickClose"
			@onClickInsure="onClickInsure"></product-choice>
		<!--    新提示-->
		<insure-notices ref="refInsureNotices" @onToInsure="goToInsure" @onToSure="goToInsure"></insure-notices>

		<!--小程序二维码-->
		<el-dialog :visible.sync="isShowQrCode" center title="微信扫一扫，有惊喜降临" width="30%">
			<div class="u-flex u-row-center" style="padding: 0 20px">
				<img :src="'data:image/png;base64,' + qrCodeUrl" alt="" />
			</div>
			<div class="u-flex u-row-center" style="margin-top: 30px">
				<el-button :loading="isShowLoading" icon="el-icon-refresh" type="primary" @click="onRefreshCode">
					刷新小程序码
				</el-button>
			</div>
		</el-dialog>

		<PayOffLineDialog ref="refPayDialog" @onPayOffLineSuccess="onPayOffLineSuccess"></PayOffLineDialog>

		<show-pdf-dialog ref="refPdf"></show-pdf-dialog>
	</basic-container>
</template>

<script>
import {
	cancelEndorse,
	downloadPolicyFeeDetail,
	fetchEmployeeListPage,
	fetchRecordList,
	getDocs,
	getEndorsementDetails,
	getPayStatus,
	getPolicyDetails,
	getRedpackDetailSync,
	getRenewAndRedoOrder,
	proxyProcess,
} from '@/api/insurance/policy'
import PayBtn from '@/components/insurance/payBtn'
import ProductChoice from '@/components/insurance/productChoice'
import ShowPdfDialog from '@/components/insurance/showPdfDialog.vue'
import {
	employeeTableOption,
	endorsementAddOption,
	endorsementChangeOption,
	endorsementDetailsOption,
	optionExpress,
	processOption,
} from '@/const/crud/insurance/policy'
import {EnumInsureType, getEnumUrlType} from '@/const/enum'
import {EnumChannelType} from '@/util/channelUtil'
import {getPageId} from '@/util/commonUtils'
import {toYYYYmmddFullDate} from '@/util/date'
import {toInsureCenter} from '@/util/insureUtils'
import {setStore} from '@/util/store'
import {handleDownCategoryFile, openPdfUrl} from '@/util/util'
import PayOffLineDialog from '@/views/insurance/product/common/payOffLineDialog'
import InsureBeginHint from '@/views/insurance/product/insureBeginHint.vue'
import rrlog from '@meibao/traceback-record'
import {InsureNotices} from 'meibao-insure'
import {isDownloadPayFile, isRenBao} from 'meibao-insure/src/util/productUtil'
import {component as Viewer} from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import pdf from 'vue-pdf'
import ProfessionNotice from '../product/professionNotice'

export default {
	components: {
		ShowPdfDialog,
		InsureNotices,
		InsureBeginHint,
		ProductChoice,
		PayBtn,
		PayOffLineDialog,
		'profession-notice': ProfessionNotice,
		pdf,
		Viewer,
	},
	data() {
		return {
			activeTab: 'information',
			orderId: '',
			policyDetails: {},
			renewFlag: false,
			payFlag: false,
			expiryDays: 0,
			statusList: [
				{
					value: 0,
					label: '退保',
					type: 'info',
				},
				{
					value: 1,
					label: '待支付',
					type: 'warning',
				},
				{
					value: 2,
					label: '处理中',
					type: '',
				},
				{
					value: 3,
					label: '保障中',
					type: 'success',
				},
				{
					value: 4,
					label: '已取消',
					type: 'info',
				},
				{
					value: 5,
					label: '已到期',
					type: 'danger',
				},
				{
					label: '待核保',
					value: 100,
					type: 'warning',
				},
				{
					label: '核保中',
					value: 101,
					type: 'warning',
				},
				{
					label: '核保拒绝',
					value: 102,
					type: 'danger',
				},
			],
			tableData: [],
			employeeList: [],
			processList: [],
			employeeSearchForm: [],
			endorsementDetails: [],
			endorsementSearchForm: {
				changeCode: '101',
			},

			// insured: {
			//     areaInfo: {},
			// },

			employeePage: {
				total: 0,
				currentPage: 1,
				pageSize: 20,
				pageSizes: [20, 50, 100, 500],
			},
			endorsementPage: {
				total: 0,
				currentPage: 1,
				pageSize: 100,
				pageSizes: [50, 100],
			},
			employeeLoading: false,
			endorsementLoading: false,
			tableLoading: false,

			employeeOption: {},
			endorsementOption: endorsementAddOption,
			// endorsementAddOption: endorsementAddOption,
			// endorsementChangeOption: endorsementChangeOption,
			endorsementDetailsOption: endorsementDetailsOption,

			endorsementDetailsDialogVisible: false,

			isEndorementPaying: false,
			isEndorementCancelling: false,
			cancelStatusIcon: 'el-icon-close',

			//PDF数据
			pdfList: {},
			//  快递单号上传
			dialogExpressVisible: false,
			optionExpress: optionExpress,
			formExpress: {
				company: '',
				trackingNumber: '',
			},
			dataCourierCompany: [],
			policySelected: null,
			viewOnly: false,
			insuredList: [],
			productId: '',
			newProductid: '',
			insureType: -1,

			replaceEmpContent: {
				one: '替换',
				oneMore: '批量替换人员',
			},
			isContentLoading: true,
			isShowLoading: false,
			isShowProductChoice: false,
			productList: [],
			rrlogEventId: null,
			isDownLoading: false,
			isShowQrCode: false,
			qrCodeUrl: '',

			//批改跳转进入
			choiceEndorseId: '',
			choiceEndorseIndex: -1,
			choiceChangeCode: '',
			currentRecordId: '',
			currentToInsure: '',
			//附件
			attachmentList: [],
			fromTypeChannel: '',
			//0替换，1改名
			isReplaceEmp: -1,
			//2 单一， 1批量
			isMoreReplace: 2,
		}
	},
	watch: {
		$route() {
			this.onInitPolicyData()
		},
	},
	computed: {
		/**
		 * 是否展示下载保单发票等
		 */
		isShowPdfPolicy() {
			let {showPolicy = false, status = ''} = this.policyDetails
			let {policyList = []} = this.pdfList
			return showPolicy && (status == 3 || status == 5) && policyList.length > 0 && this.isShowPdf
		},

		/**
		 * 是否展示下载保单发票等
		 */
		isShowPdfInvoice() {
			let {showPolicy = false, status = ''} = this.policyDetails
			let {invoiceList = []} = this.pdfList
			return showPolicy && (status == 3 || status == 5) && invoiceList.length > 0 && this.isShowPdf
		},

		/**
		 * 获取当前保单状态
		 */
		getPolicyStatus() {
			let {status = ''} = this.policyDetails
			return this.statusList.find((item) => item.value === status) || {}
		},

		EnumInsureType() {
			return EnumInsureType
		},
		onGetDes() {
			return isRenBao(this.insureType)
				? ['投保人', '投保人：', '被保险人', '被保险人：', '身份证号码：']
				: ['投保企业', '企业名称：', '被保企业/个人', '企业名称：', '统一信用代码：']
		},
		//获取订单支付信息
		getOrderData() {
			let {paySource, certFile, productId, newProductid, productType, insureType} = this.policyDetails
			return {
				paySource,
				certFile,
				productId: newProductid,
				productType,
				sourceProductId: productId,
				orderId: this.orderId,
				isIndex: false,
				insureType,
			}
		},
		//处理第三方跳转
		isShowMoreReplaceThird() {
			return this.fromTypeChannel !== EnumChannelType.hekang
		},
		//显示批增按钮
		isShowAddButton() {
			let {increase: {allow = 2, showButton = 2} = {}} = this.policyDetails
			return (allow === 1 || showButton === 1) && !this.viewOnly
		},
		//显示批改按钮
		isShowReplaceButton() {
			let {replace: {allow = 2, showButton = 2} = {}} = this.policyDetails
			return (allow === 1 || showButton === 1) && !this.viewOnly
		},
		//批量替换按钮
		isShowReplaceMoreButton() {
			let {replace: {allowBatch = 2, showBatchButton = 2} = {}} = this.policyDetails
			return (allowBatch === 1 || showBatchButton === 1) && this.isShowMoreReplaceThird
		},
		//改名按钮
		isShowRenameButton() {
			let {rename: {allow = 2, showButton = 2} = {}} = this.policyDetails
			return (allow === 1 || showButton === 1) && !this.viewOnly
		},
		//批量替换按钮
		isShowRenameMoreButton() {
			let {rename: {allowBatch = 2, showBatchButton = 2} = {}} = this.policyDetails
			return (allowBatch === 1 || showBatchButton === 1) && this.isShowMoreReplaceThird
		},

		/**
		 * 续保提醒
		 */
		getShowRenewTips() {
			let {renewFlag = false, expiryDays = 0} = this.policyDetails
			if (renewFlag) {
				return {
					renewTips:
						expiryDays > 0
							? '您的保单将于' + expiryDays + '天后过期，建议您及时续保，防止断保用工风险，如您已续保，请忽略。'
							: '您的保单已经过期，建议您立即续保，防止断保用工风险，如您已续保，请忽略。',
					renewTipsType: expiryDays > 0 ? 'warning' : 'error',
				}
			}
			return null
		},
		//博维的过期保单，不显示下载发票，保单PDF
		isShowPdf() {
			let {brokerInfo: {productBrokerType = 2} = {}, status = 0} = this.policyDetails
			return productBrokerType !== 1 || status !== 5
		},
	},
	created() {
		this.onInitPolicyData()
	},
	methods: {
		isDownloadPayFile,

		/**
		 * 获取保单数据
		 */
		async onInitPolicyData() {
			this.orderId = this.$route.params.id
			let {viewonly = false, changeCode = 0, choiceEndorseId = '', fromTypeChannel = ''} = this.$route.query
			this.insuredList = []
			this.policyDetails = {}
			this.fromTypeChannel = fromTypeChannel

			const resPolicyData = (await getPolicyDetails(this.orderId)) || {}
			let {code, data} = resPolicyData.data || {}
			if (code !== 0) {
				return
			}
			this.policyDetails = data
			let {
				productId,
				insureType,
				newProductid = '',
				effectiveDate,
				expiryDate,
				insureds = [],
				holder = {},
				payOrderId = '',
				policyNo = '',
				renewFlag = false,
				status = 0,
				term = 0,
				expiryDays = 0,
				allowAdd = false,
				allowModify = false,
				attach = [],
			} = this.policyDetails

			//只读
			this.viewOnly = viewonly
			this.productId = productId
			this.newProductid = newProductid
			this.insureType = insureType

			//处理时间
			if (!effectiveDate.includes('-')) {
				this.policyDetails.effectiveDate = toYYYYmmddFullDate(effectiveDate)
				this.policyDetails.expiryDate = toYYYYmmddFullDate(expiryDate)
			}

			//人员option
			this.employeeOption = this.deepClone(employeeTableOption)
			//是否展示menu
			// 1，可以替换， 或者可以改名
			this.employeeOption.menu = (this.isShowReplaceButton || this.isShowRenameButton) && status === 3 && !this.viewOnly

			// //如果为驾意险则换option
			// if (this.insureType === 14) {
			// 	this.employeeOption = this.deepClone(optionEmployeeView_detail_car_14)
			// 	this.employeeOption.header = true
			// } else {
			// 	this.viewOnly = viewonly
			// 	this.employeeOption = this.deepClone(employeeTableOption)
			// 	if (this.viewOnly) {
			// 		//只读
			// 		this.employeeOption.menu = false
			// 	}
			// }
			this.isContentLoading = false
			// 被保企业为空时取投保企业
			if (!this.validatenull(insureds)) {
				this.insuredList = insureds
			} else {
				this.insuredList.push(holder)
			}
			this.payOrderId = payOrderId
			this.attachmentList = attach

			this.renewFlag = renewFlag
			this.payFlag = status === 1
			this.expiryDays = expiryDays
			// if (this.renewFlag) {
			// 	if (this.expiryDays > 0) {
			// 		this.renewTips =
			// 			'您的保单将于' + this.expiryDays + '天后过期，建议您及时续保，防止断保用工风险，如您已续保，请忽略。'
			// 		this.renewTipsType = 'warning'
			// 	} else {
			// 		this.renewTips = '您的保单已经过期，建议您立即续保，防止断保用工风险，如您已续保，请忽略。'
			// 		this.renewTipsType = 'error'
			// 	}
			// }

			this.getEmployeeList()
			if (!changeCode) {
				this.getEndorsementList()
			}
			// //只有处于“保障中”状态可以批增或批改
			// if (status === 3) {
			// 	//获取保单是否有其他批单
			// 	let resultCheck =
			// 		(await proxyProcess({applyId: this.orderId, proxyFlag: 'check_endorse'}).catch(() => {})) || {}
			// 	let {originCode = '', originMsg = '', msg = ''} = resultCheck.data || {}
			// 	let isNoHas = originCode === '200' || originCode === '0'
			// 	//批增替换操作
			// 	if (!isNoHas) {
			// 		await this.$alert(msg || originMsg || '服务繁忙，请稍后再试！', '提示', {
			// 			confirmButtonText: '我知道了',
			// 		})
			// 	}
			// }

			//获取保单和发票
			if (status === 3 || status === 5) {
				let query = {
					policyNo,
				}
				const resDocs = (await getDocs(query)) || {}
				let {code, data} = resDocs.data || {}
				if (code === 0) {
					this.pdfList = data
				}
			}
			//如果保单为保障中
			if (status === 3) {
				getRedpackDetailSync(this.orderId)
					.then((maUrl) => {
						this.qrCodeUrl = maUrl
						this.isShowQrCode = true
					})
					.catch(() => {})
			}
			//是否是从批单传递过来的！需要切换table
			if (changeCode) {
				this.choiceEndorseId = choiceEndorseId
				this.choiceChangeCode = changeCode
				this.activeTab = 'endorsement'
				this.endorsementSearchForm.changeCode = changeCode == '101' || changeCode == '102' ? changeCode : '999'
				this.endorsementTypeChange()
			}
		},

		handleViewSurrender(row) {
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/policy/surrender/detail/${row.id}`,
				}),
			})
		},
		handleSubmitMaterials(row) {
			let {id = '', applyType = ''} = row
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					// src: `/policy/surrender/apply/${row.id}`,
					src: `/policy/surrender/${applyType === 201 ? 'apply' : 'supplement'}/${id}`,
				}),
			})
		},
		handleSupplementMaterials(row) {
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/policy/surrender/supplement/${row.id}`,
				}),
			})
		},
		handleSubmitExpressNo(row) {
			proxyProcess(
				Object.assign({
					proxyFlag: 'apply_express',
				}),
			)
				.then((response) => {
					let data = response.data.data
					this.dataCourierCompany.length = 0
					if (!this.validatenull(data)) {
						data.forEach((item, index) => {
							this.dataCourierCompany.push({
								value: item.value,
								label: item.name,
							})
						})
						this.optionExpress.column[0].dicData = this.dataCourierCompany
					}
					this.policySelected = row
					this.dialogExpressVisible = true
				})
				.catch(() => {})
				.finally(() => {})
		},
		handleTrackingNumberUpload(form, done) {
			proxyProcess(
				Object.assign({
					proxyFlag: 'edit_express',
					applyId: this.policySelected.id,
					data: {
						expressCompany: this.formExpress.company,
						expressNo: this.formExpress.trackingNumber,
					},
				}),
			)
				.then((response) => {
					this.$message({
						message: '快递单号 上传成功',
						type: 'success',
					})
				})
				.catch(() => {})
				.finally(() => {
					done()
					this.dialogExpressVisible = false
				})
		},
		/**
		 * 处理展示pdf
		 * @param type 1 保单， 2 批单 3 发票
		 * @param row
		 */
		onShowPdfDialog(type, row) {
			let tempData = type === 2 ? row : this.policyDetails
			tempData.orderId = this.orderId
			//批单
			let {holder: {unitName = ''} = {}} = this.policyDetails
			tempData.unitName = unitName
			//弹窗
			this.$refs.refPdf.handleViewSurrenderDocs(tempData, type === 3)
		},
		//  获取雇员列表
		getEmployeeList() {
			this.employeeLoading = true

			let employeeListParams = {
				orderId: this.orderId,
				pageNo: this.employeePage.currentPage,
				pageSize: this.employeePage.pageSize,
			}

			fetchEmployeeListPage(Object.assign(employeeListParams, this.employeeSearchForm))
				.then((response) => {
					let tempData = response.data.data
					if (!this.validatenull(tempData)) {
						let {total, records} = tempData
						//处理数据
						let isHasHigh = false
						records.forEach((itemData) => {
							let {effectiveDate, expiryDate, price = 0, workType = ''} = itemData
							if (!effectiveDate.includes('-')) {
								itemData.effectiveDate = toYYYYmmddFullDate(effectiveDate)
								itemData.expiryDate = toYYYYmmddFullDate(expiryDate)
							}
							itemData.price = price > 0 ? `${price / 100}元` : 0
							if (workType) {
								isHasHigh = true
							}
						})
						//处理option
						if (!isHasHigh) {
							let tempData = this.findObject(this.employeeOption.column, 'workType') || null
							if (tempData) {
								tempData.hide = true
							}
						}
						this.employeeList = records
						if (this.insureType === 14) {
							this.employeePage.total = 0
						} else {
							this.employeePage.total = total
							for (let index in this.employeeList) {
								this.employeeList[index].profession =
									this.employeeList[index].category.categoryName +
									' - ' +
									this.employeeList[index].category.professionLevel +
									'类'
							}
						}
					}
				})
				.catch(() => {})
				.finally(() => {
					this.$nextTick(() => {
						this.employeeLoading = false
					})
				})
		},
		//  获取批增/改记录
		getEndorsementList() {
			this.endorsementLoading = true

			let endorsementListParams = {
				orderId: this.orderId,
				pageNo: this.endorsementPage.currentPage,
				pageSize: this.endorsementPage.pageSize,
			}

			fetchRecordList(Object.assign(endorsementListParams, this.endorsementSearchForm))
				.then((response) => {
					if (!this.validatenull(response.data.data.total)) {
						this.endorsementPage.total = response.data.data.total
					}
					let recordList = response.data.data.records || []
					this.tableData = []

					recordList.forEach((item, index) => {
						let {changeCode = 0, createTime = '', effectiveDate = '', recordId = ''} = item
						if (!effectiveDate.includes('-')) {
							item.effectiveDate = toYYYYmmddFullDate(effectiveDate)
							item.createTime = toYYYYmmddFullDate(createTime)
						}
						if (changeCode === 101) {
							item.details = '新增' + item.remark.match(/\d{17}/g).length + '人'
						} else if (changeCode === 102) {
							item.employeeOld = ''
							item.employeeNew = ''
							let keyword1 = '替换保障人员：'
							let keyword2 = '变更为：'
							let pos1 = item.remark.indexOf(keyword1)
							let pos2 = item.remark.indexOf(keyword2)
							if (pos1 !== -1 && pos2 !== -1) {
								item.employeeOld = item.remark.substring(pos1 + keyword1.length, pos2)
								item.employeeNew = item.remark.substring(pos2 + keyword2.length, item.remark.length)
							}
						}
						if (this.choiceEndorseId == recordId && this.choiceEndorseIndex === -1) {
							this.choiceEndorseIndex = index
							//如果是批增，则直接弹出详情数据
							if (this.choiceChangeCode == 101) {
								this.handleViewEndorsement(item)
							}
						}
					})
					this.tableData = recordList
				})
				.catch(() => {})
				.finally(() => {
					this.$nextTick(() => {
						this.endorsementLoading = false
						if (this.$refs.crud_change) {
							this.$refs.crud_change.doLayout()
						}
					})
				})
		},
		getProcessList() {
			this.endorsementLoading = true

			proxyProcess(
				Object.assign({
					page: this.endorsementPage.currentPage,
					pageSize: this.endorsementPage.pageSize,
					proxyFlag: 'apply_list',
					data: {
						orderId: this.orderId,
					},
				}),
			)
				.then((response) => {
					this.endorsementPage.total = response.data.data.total
					this.tableData = []
					if (this.endorsementPage.total > 0) {
						this.tableData = response.data.data.records
					}
					this.tableData.forEach((item, index) => {
						if (this.choiceEndorseId == item.recordId && this.choiceEndorseIndex === -1) {
							this.choiceEndorseIndex = index
							// //如果是批增，则直接弹出详情数据
							// if (this.choiceChangeCode == 101) {
							//   this.handleViewEndorsement(item)
							// }
						}
					})
				})
				.catch(() => {})
				.finally(() => {
					this.$nextTick(() => {
						this.endorsementLoading = false
						if (this.$refs.crud_change) {
							this.$refs.crud_change.doLayout()
						}
					})
				})
		},
		//  分页
		employeeSizeChange(pageSize) {
			this.employeePage.currentPage = 1
			this.employeePage.pageSize = pageSize
			this.getEmployeeList()
		},
		employeeCurrentChange(current) {
			this.employeePage.currentPage = current
			this.getEmployeeList()
		},
		//  搜索
		employeeSearchChange(form, done) {
			if (!this.validatenull(form.empIdNo)) {
				this.employeeSearchForm.empName = form.empIdNo
			} else {
				this.employeeSearchForm = form
			}
			this.employeePage.currentPage = 1
			this.getEmployeeList()

			done()
		},
		//  刷新
		employeeRefreshChange() {
			this.getEmployeeList()
		},
		//
		endorsementSizeChange(pageSize) {
			this.endorsementPage.pageSize = pageSize
			this.endorsementPage.currentPage = 1
			this.getEndorsementList()
		},
		endorsementCurrentChange(current) {
			this.endorsementPage.currentPage = current
			this.getEndorsementList()
		},
		endorsementSearchChange(form, done) {
			this.endorsementSearchForm = form
			this.endorsementPage.currentPage = 1
			this.getEndorsementList()
			done()
		},
		endorsementRefreshChange() {
			this.getEndorsementList(this.endorsementPage)
		},
		endorsementTypeChange() {
			switch (this.endorsementSearchForm.changeCode) {
				case '101':
					this.endorsementOption = endorsementAddOption
					this.getEndorsementList()
					break
				case '102':
					this.endorsementOption = endorsementChangeOption
					this.getEndorsementList()
					break
				case '999':
					this.endorsementOption = processOption
					this.getProcessList()
					break
				default:
					break
			}
		},
		endorsementRowStyle({row, column, rowIndex}) {
			if (rowIndex == this.choiceEndorseIndex && this.choiceEndorseId == row.recordId) {
				return {
					backgroundColor: '#ecf5ff',
				}
			}
		},

		/**
		 * 判断按钮提醒  整合
		 * @param type -1 批增 0 替换 1 改名
		 */
		handleButtonHint(type, isSingle = true) {
			//赋值
			this.isReplaceEmp = type
			let tempHint = ''
			let emptyHint = '提示内容为空，不允许该操作！！'
			let {
				increase: {allow: allowIncrease = 2, msg: increaseButtonMsg = emptyHint} = {},
				replace: {allow: allowReplace = 2, allowBatch: allowReplaceBatch = 2, msg: replaceButtonMsg = emptyHint} = {},
				rename: {allow: allowRename = 2, allowBatch: allowRenameBatch = 2, msg: renameButtonMsg = emptyHint},
			} = this.policyDetails

			switch (type) {
				case -1:
					//批增
					if (allowIncrease !== 1) {
						tempHint = increaseButtonMsg
					}
					break
				case 0:
					//替换
					if ((isSingle && allowReplace !== 1) || (!isSingle && allowReplaceBatch !== 1)) {
						tempHint = replaceButtonMsg
					}
					break
				case 1:
					//改名
					if ((isSingle && allowRename !== 1) || (!isSingle && allowRenameBatch !== 1)) {
						tempHint = renameButtonMsg
					}
					break
				default:
					break
			}
			if (tempHint) {
				this.$alert(tempHint, '提示', {
					confirmButtonText: '我知道了',
				}).then(() => {})
				return false
			}
			return true
		},

		/**
		 *  批增
		 * @param isReplaceEmp 0 替换 1 改名 -1 批增
		 */
		async handleReplaceAdd() {
			//判断是否能继续
			if (!this.handleButtonHint(-1)) {
				return
			}
			this.isJudgeCenter(EnumInsureType.add)
		},

		/**
		 * 批量操作
		 * @param row 批量操作 0 替换 1 改名
		 */
		async handleReplaceMore(isReplaceEmp) {
			//判断是否能继续
			if (!this.handleButtonHint(isReplaceEmp, false)) {
				return
			}
			this.isMoreReplace = 1
			this.isJudgeCenter(EnumInsureType.change)
		},

		/**
		 * 单一操作批改选定的单个人员
		 * @param row 单一操作
		 */
		async handleReplaceSingle(row, isReplaceEmp) {
			//判断是否能继续
			if (!this.handleButtonHint(isReplaceEmp, true)) {
				return
			}
			this.isMoreReplace = 2
			this.isJudgeCenter(EnumInsureType.change, `${row.empIdNo}`)
		},

		handleViewEndorsement(row) {
			this.tableLoading = true
			getEndorsementDetails(row.recordId)
				.then((response) => {
					let details = response.data.data
					this.endorsementDetails.length = 0
					if (!this.validatenull(details)) {
						details.forEach((item, index) => {
							let {category = {}} = item

							item.industry = category.industry || ''
							item.type = category.type || ''
							item.categoryName = category.categoryName || ''

							this.endorsementDetails.push(item)
						})
						this.endorsementDetailsDialogVisible = true
					}
				})
				.catch(() => {})
				.finally(() => {
					this.tableLoading = false
				})
		},
		handleCancelEndorsement(row) {
			if (!this.isEndorementCancelling) {
				this.cancelStatusIcon = 'el-icon-loading'
				this.isEndorementCancelling = true

				var message = ''

				cancelEndorse(row.payOrderId)
					.then((response) => {
						this.$nextTick(() => {
							this.getEndorsementList(this.endorsementPage)
						})
					})
					.catch((error = {}) => {
						message = error.message
					})
					.finally(() => {
						this.cancelStatusIcon = 'el-icon-check'
						this.isEndorementCancelling = false
						if (!this.validatenull(message)) {
							this.$alert(message, '提示', {
								confirmButtonText: '确定',
							})
						}
					})
			}
		},
		//续保
		async handleRenew() {
			//操作类型
			try {
				this.isShowLoading = true
				//判断不同接口
				let tempOrder = await getRenewAndRedoOrder({orderId: this.orderId, type: 'RENEW'})
				let {data: {products = [], popup = false} = {}} = tempOrder.data
				if (products.length <= 0) {
					this.$alert(`该保单不支持续保，请重新选择投保产品！`, '提示', {
						confirmButtonText: '确定',
					}).then(() => {})
					return
				}
				this.rrlogEventId = rrlog.capture(
					`续保`,
					{
						orderId: this.orderId,
					},
					{
						sign: true,
					},
				)
				if (!popup) {
					//不弹窗，默认第一个，直接处理
					//直接保存数据，进入投保信息
					this.onClickInsure(products[0])
					return
				}
				//剩下的都弹窗，自主选择
				this.productList = products
				this.isShowProductChoice = true
			} catch (error) {
			} finally {
				this.isShowLoading = false
			}

			// renewOrder(this.orderId)
			// 	.then((response) => {
			// 		let {data = []} = response.data
			// 		if (data.length <= 0) {
			// 			this.$alert(`该保单不支持续保，请重新选择投保产品！`, '提示', {
			// 				confirmButtonText: '确定',
			// 			}).then(() => {})
			// 		} else if (data.length === 1) {
			// 			//直接保存数据，进入投保信息
			// 			let {pid, newProductId = ''} = data[0]
			// 			this.productId = pid
			// 			this.newProductid = newProductId
			// 			//判断是否走产品中心
			// 			this.isJudgeCenter(EnumInsureType.renew)
			// 		} else {
			// 			//选择产品
			// 			this.productList = data
			// 			this.isShowProductChoice = true
			// 		}
			// 	})
			// 	.catch(() => {})
			// 	.finally(() => {
			// 		this.isShowLoading = false
			// 	})
		},
		/**
		 * 弹窗 投保提醒，包含批增
		 * 批增也要调用接口判断跳转
		 */
		async isJudgeCenter(type, recordId = '') {
			try {
				this.isShowLoading = true
				//任何操作都要先确定是否能继续！！！！！
				if (!this.newProductid) {
					//旧的禁止投保
					await this.$alert(`错误代码：P100-${this.productId}-002：保单数据异常，请联系管理员更新数据！`, '提示', {})
					return
				}
				//获取保单是否有其他批单
				let resultCheck = (await proxyProcess({applyId: this.orderId, proxyFlag: 'check_endorse'})) || {}
				let {originCode = '', originMsg = '', msg = ''} = resultCheck.data || {}
				//批增替换操作
				if (originCode !== '200' && originCode !== '0') {
					await this.$alert(msg || originMsg || 'check_endorse服务异常，请稍后再试！', '提示', {
						confirmButtonText: '我知道了',
					})
					return
				}
				this.currentRecordId = ''

				this.isShowLoading = true
				this.currentToInsure = type
				this.currentRecordId = recordId
				let tempReq = {productId: this.newProductid, sourceProductId: this.productId, orderId: this.orderId}
				if (type === EnumInsureType.add) {
					tempReq.operate = 2
				} else if (type === EnumInsureType.change) {
					tempReq.operate = 3
				}
				//投保提醒
				await this.$refs.refInsureNotices.onGetHintInfoData(tempReq)
			} catch (error) {
				this.$alert(error.message || '服务异常，请稍后再试！', '提示', {
					confirmButtonText: '我知道了',
				})
			} finally {
				this.isShowLoading = false
			}
		},
		//判断是续保还是批增
		goToInsure() {
			let pageId = getPageId()
			this.rrlogEventId = rrlog.capture(
				this.currentToInsure === EnumInsureType.renew ? '续保' : `去批增`,
				{
					orderId: this.orderId,
					recordId: this.currentToInsure === EnumInsureType.add ? this.currentRecordId : '',
				},
				{
					sign: true,
				},
			)
			if (this.rrlogEventId) {
				setStore({name: `rrlog_eventid_${pageId}`, content: this.rrlogEventId, type: 'session'})
			}
			let {payId = ''} = this.policyDetails
			let tempData = {
				orderId: `${this.orderId}`,
				insureType: this.insureType,
				fromType: getEnumUrlType(this.currentToInsure),
				productId: this.newProductid,
				sourceProductId: this.productId,
			}
			if (this.currentToInsure === EnumInsureType.change) {
				//替换 0替换，1改名
				Object.assign(tempData, {
					isReplaceEmp: this.isReplaceEmp,
					empIdNo: this.currentRecordId,
					isMoreReplace: this.isMoreReplace,
				})
			} else {
				//投保
				Object.assign(tempData, {
					act: this.currentToInsure,
					recordId: `${this.currentRecordId}`,
					pageId,
					productId: this.newProductid,
					insureType: this.insureType,
					payId,
					sourceProductId: this.productId,
				})
			}
			//跳转投保
			toInsureCenter(tempData)
		},
		endorsementCellStyle({row, column, rowIndex, columnIndex}) {
			if (columnIndex === 5) {
				if (row.status === 1) {
					return {
						color: 'red',
						fontWeight: 'bold',
					}
				}
			}
		},
		//刷新
		onRefresh() {
			//刷新，要调取 getPayStatus 接口
			this.isContentLoading = true
			this.insuredList = []
			let {status, payOrderId} = this.policyDetails
			if (status === 1 && payOrderId) {
				getPayStatus(payOrderId)
					.then(() => {})
					.catch(() => {})
					.finally(() => {
						this.onInitPolicyData()
					})
			} else {
				this.onInitPolicyData()
			}
		},
		onPayOffLineSuccess(refresh) {
			if (this.validatenull(refresh)) {
				//刷新
				this.onRefresh()
			} else {
				//刷新批改记录
				this.getEndorsementList()
			}
		},
		onCopy(text) {
			//复制功能
			this.$Clipboard({
				text,
			})
				.then(() => {
					this.$message.success('复制成功')
				})
				.catch(() => {
					this.$message.success('复制失败')
				})
		},
		getItemOrderData({paySource, certFile, productId, insureType, payOrderId, subOrderId, payMoney}) {
			//在线支付 传递payOrderId
			let orderTemp = paySource == 1 ? payOrderId : subOrderId
			return {
				isAdd: true,
				currentOderId: this.orderId,
				paySource,
				certFile,
				productId: this.policyDetails.newProductid || '',
				sourceProductId: productId,
				insureType,
				orderId: orderTemp,
				isIndex: true,
				totalPrice: (payMoney / 100).toFixed(2),
			}
		},
		onClickInsure(itemData) {
			this.isShowProductChoice = false
			let {sourceProductId, productId = ''} = itemData
			this.productId = sourceProductId
			if (productId) {
				this.newProductid = productId
			}
			//判断产品中心
			this.isJudgeCenter(EnumInsureType.renew)
		},
		onClickClose() {
			this.isShowProductChoice = false
		},
		//刷新小程序码
		onRefreshCode() {
			this.isShowLoading = true
			getRedpackDetailSync(this.orderId)
				.then((tempCodeUrl) => {
					this.qrCodeUrl = tempCodeUrl
					this.$message.success('小程序码已刷新！')
				})
				.catch(() => {})
				.finally(() => {
					this.isShowLoading = false
				})
		},
		//下载人员清单
		onDownloadEmp() {
			this.isShowLoading = true
			let path = `/dist/bowei/file?path=/export/emplist`
			let fileName = `${this.policyDetails.policyNo}_emp.xls`
			handleDownCategoryFile(path, {orderId: this.orderId}, fileName)
				.then(() => {
					this.$message.success('人员清单下载成功！')
				})
				.catch(() => {})
				.finally(() => {
					this.isShowLoading = false
				})
		},
		//下载
		onDownloadPayFile({subOrderId = ''}) {
			this.isShowLoading = true
			downloadPolicyFeeDetail(subOrderId)
				.then((res) => {
					let {code = -1, data = ''} = res.data
					if (code !== 200 || !data) {
						this.$message.error('下载失败！')
						return
					}
					this.$message.success('下载成功！')
					openPdfUrl(data)
				})
				.catch(() => {})
				.finally(() => {
					this.isShowLoading = false
				})
		},
		//直接打开
		onDownloadAttach(row) {
			window.open(row, '_blank')
		},
		//对公支付
		onToOfflinePay(offlineData) {
			this.$refs.refPayDialog.dealData(offlineData)
		},
	},
	beforeRouteEnter(to, from, next) {
		//判断如果是从批单进入的
		next((vm) => {
			if (from.path.indexOf('policyCheckList') === -1) {
				vm.$nextTick(() => {
					//不需要弹窗
					vm.choiceEndorseIndex = 1000
				})
			}
		})
	},
}
</script>

<style lang="scss" scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
	display: table;
	content: '';
}

.clearfix:after {
	clear: both;
}

::v-deep .el-radio {
	margin-right: 10px !important;
}

::v-deep .avue-crud__right .el-icon-download:after {
	content: '' !important;
}
</style>
